module.exports = __webpack_public_path__ + "static/media/allergen_fish.449817e7.png";